import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState, useEffect } from 'react';
import {
  Stack,
  Button,
  Container,
  Typography,
  Box,
  Card,
  Popover,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  Chip,
  Paper,
  Grid,
  Avatar,
  Badge,
  alpha,
  useTheme,
  IconButton,
  MenuItem,
  Divider
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import moment from 'moment';
import { getApi, patchApi } from 'views/services/api';
import AddProperty from './AddEmployee.js';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ChangeShift from './ChangeShift';
import EditEmployee from './EditEmployee';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  People as PeopleIcon,
  Person as PersonIcon,
  Work as WorkIcon,
  Schedule as ScheduleIcon,
  AttachMoney as MoneyIcon,
  CalendarToday as CalendarIcon,
  Security as SecurityIcon,
  TrendingUp as TrendingUpIcon,
  PersonAdd as PersonAddIcon,
  Edit as EditActionIcon,
  Visibility as ViewIcon,
  Delete as DeleteActionIcon,
  Assignment as AssignmentIcon,
  AccessTime as AccessTimeIcon,
  AdminPanelSettings as AdminIcon,
  Groups as GroupsIcon,
  Block as BlockIcon,
  CheckCircleOutline as CheckCircleOutlineIcon
} from '@mui/icons-material';
import Switch from '@mui/material/Switch';

// List of menu items - ACTUALIZADO con los nuevos nombres en español
const menuItems = [
  'Tablero Principal',
  'Calendario de Reservas',
  'Gestión de Habitaciones',
  'Pre-Reservas',
  'Conversaciones WhatsApp',
  'Reservas Confirmadas',
  'Centro de Tareas',
  'Control de Limpieza',
  'Gestión de Lavandería',
  'Operaciones de Caja',
  'Apertura de Caja',
  'Cierre de Caja',
  'Registro de Gastos',
  'Categorías de Gastos',
  'Gestión de Facturas',
  'Pagos de Suscripción',
  'Gestión de Divisas',
  'Centro de Restaurante',
  'Órdenes de Cocina (KOT)',
  'Reportes de Cocina',
  'Base de Clientes',
  'Administración de Personal',
  'Historial de Cajas',
  // Habilita a cuadrar el efectivo de una caja ya cerrada. Se verifica en el
  // servidor (controllers/cashRegister/scope.js), no solo en el menú.
  'Arqueo de Caja',
  // Habilita a ver el efectivo que los gerentes tienen por depositar y a
  // registrar depósitos. Se verifica en el servidor
  // (controllers/cashCustody/scope.js), no solo en el menú.
  'Custodia de Efectivo',
  // Habilita a ver y administrar el plan de cuentas. Se verifica en el servidor
  // (controllers/accounting/scope.js). Activar el módulo queda solo para el
  // administrador del hotel.
  'Plan de Cuentas',
  // Habilita a ver los reportes contables (mayor, comprobación, balance,
  // resultados). Solo lectura; se verifica en controllers/accounting/scope.js.
  'Reportes Contables',
  // Habilita a registrar y anular vouchers (asientos manuales). Escribe en el
  // libro; se verifica en controllers/accounting/scope.js.
  'Vouchers Contables',
  'Reporte de Ventas Diarias',
  'Análisis Financiero General',
  'Registro de Huéspedes',
  'Planes de Suscripción',
  'Configuración WhatsApp',
  'Configuración del Hotel',
  'Reportar Problemas'
];

const StaffManagment = () => {
  const theme = useTheme();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openChangeShift, setOpenChangeShift] = useState(false);
  const [showInactive, setShowInactive] = useState(false);
  const [currentShift, setCurrentShift] = useState('');
  const [employeeID, setEmployeeId] = useState('');
  const [staffData, setstaffData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowData, setRowData] = useState();
  const [permissionsAnchorEl, setPermissionsAnchorEl] = useState(null);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const currency = hotel?.currency || 'USD';
  const navigate = useNavigate();

  //function for the dropdowns
  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setRowData(row);
  };

  const handlePermissionsClick = (event, row) => {
    setPermissionsAnchorEl(event.currentTarget);
    setRowData(row);
    setSelectedPermissions(row.permissions || []);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setPermissionsAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const openPermissions = Boolean(permissionsAnchorEl);

  // function for fetching all the contacts data from the db
  const fetchstaffData = async () => {
    try {
      // const response = await getApi(`api/employee/viewallemployee/${hotel._id}`);
      const response = await getApi(`api/employee/viewallemployee/${hotel?.hotelId}`);
      setstaffData(response?.data?.employeeData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchstaffData();
  }, [openAdd, openEdit, openChangeShift]);

  // add employee dialog
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  // edit employee dialog
  const handleOpenEditEmployee = (_id) => {
    console.log('_id in handle edit =>', _id);
    setOpenEdit(true);
  };
  const handleCloseEditEmployee = () => {
    setOpenEdit(false);
    handleClose();
  };

  // view employee
  const handleOpenview = (_id) => {
    console.log('_id ==>', _id);
    navigate(`/dashboard/employee/view/${rowData?._id}`);
  };

  // change shift dialog
  const handleOpenChangeShift = (employeeData) => {
    setCurrentShift(employeeData.shift);
    setEmployeeId(employeeData._id);
    setOpenChangeShift(true);
  };
  const handleCloseChangeShift = () => {
    setOpenChangeShift(false);
  };

  const handlePermissionsChange = (event) => {
    const value = event.target.name;
    setSelectedPermissions((prev) => (prev?.includes(value) ? prev.filter((permission) => permission !== value) : [...prev, value]));
  };

  const handleSavePermissions = async (id) => {
    if (!id) {
      console.error('ID del empleado no válido');
      return;
    }

    if (!Array.isArray(selectedPermissions)) {
      console.error('Permisos no válidos:', selectedPermissions);
      return;
    }

    try {
      await patchApi(`api/employee/addPermissions/${id}`, {
        permissions: selectedPermissions
      });

      fetchstaffData(); // Actualiza los datos en pantalla
      handleClose(); // Cierra el popover
    } catch (error) {
      console.error('Error al guardar permisos:', error);
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    try {
      await patchApi(`api/employee/toggle-status/${id}`);
      fetchstaffData();
      handleClose();
    } catch (error) {
      console.error('Error al cambiar estado del empleado:', error);
    }
  };

  // Función para obtener las iniciales del nombre
  const getInitials = (name) => {
    if (!name) return '?';
    const nameParts = name.split(' ');
    if (nameParts.length >= 2) {
      return `${nameParts[0].charAt(0)}${nameParts[1].charAt(0)}`.toUpperCase();
    }
    return name.charAt(0).toUpperCase();
  };

  // Función para obtener color del avatar según el tipo de empleado
  const getAvatarColor = (employeeType) => {
    const colors = {
      admin: theme.palette.error.main,
      manager: theme.palette.warning.main,
      receptionist: theme.palette.primary.main,
      housekeeping: theme.palette.success.main,
      kitchen: theme.palette.info.main,
      maintenance: theme.palette.secondary.main
    };
    return colors[employeeType?.toLowerCase()] || theme.palette.grey[600];
  };

  // Función para obtener color del chip según el turno
  const getShiftColor = (shift) => {
    const colors = {
      morning: 'success',
      afternoon: 'warning',
      night: 'info',
      mañana: 'success',
      tarde: 'warning',
      noche: 'info'
    };
    return colors[shift?.toLowerCase()] || 'default';
  };

  // Función para traducir tipos de empleado
  const getEmployeeTypeSpanish = (type) => {
    const types = {
      admin: 'Administrador',
      manager: 'Gerente',
      receptionist: 'Recepcionista',
      housekeeping: 'Limpieza',
      kitchen: 'Cocina',
      maintenance: 'Mantenimiento'
    };
    return types[type?.toLowerCase()] || type || 'No especificado';
  };

  // Filtrar datos
  const filteredStaffData = staffData?.filter((emp) => (showInactive ? true : emp.isActive !== false));

  // Calcular estadísticas
  const totalEmployees = filteredStaffData?.length || 0;
  const totalSalaries = filteredStaffData?.reduce((sum, emp) => sum + (emp.salary || 0), 0) || 0;
  const averageSalary = totalEmployees > 0 ? totalSalaries / totalEmployees : 0;

  const columns = [
    {
      field: `fullName`,
      headerName: 'Empleado',
      flex: 1.5,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        const handleOpenViewNameClick = () => {
          navigate(`/dashboard/employee/view/${params.row._id}`);
        };
        const avatarColor = getAvatarColor(params.row.employeeType);
        const permissionsCount = params.row.permissions?.length || 0;

        return (
          <Box onClick={() => handleOpenViewNameClick()} sx={{ cursor: 'pointer' }}>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Badge
                badgeContent={permissionsCount}
                color="primary"
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
              >
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: alpha(avatarColor, 0.1),
                    color: avatarColor,
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    border: `2px solid ${alpha(avatarColor, 0.2)}`
                  }}
                >
                  {getInitials(params.value)}
                </Avatar>
              </Badge>
              <Box>
                <Typography
                  variant="body2"
                  fontWeight={600}
                  sx={{
                    '&:hover': {
                      color: theme.palette.primary.main
                    }
                  }}
                >
                  {params.value}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {permissionsCount} permisos asignados
                </Typography>
              </Box>
            </Stack>
          </Box>
        );
      }
    },
    {
      field: 'employeeType',
      headerName: 'Cargo',
      flex: 1,
      renderCell: (params) => {
        const color = getAvatarColor(params.value);
        return (
          <Chip
            label={getEmployeeTypeSpanish(params.value)}
            size="small"
            variant="outlined"
            sx={{
              borderColor: color,
              color: color,
              borderRadius: 2,
              fontWeight: 500,
              fontSize: '0.75rem'
            }}
            icon={<WorkIcon sx={{ fontSize: 14, color: color }} />}
          />
        );
      }
    },
    {
      field: 'shift',
      headerName: 'Turno',
      flex: 1,
      renderCell: (params) => (
        <Chip
          label={params.value || 'No asignado'}
          color={getShiftColor(params.value)}
          size="small"
          variant="filled"
          icon={<AccessTimeIcon sx={{ fontSize: 14 }} />}
          sx={{
            borderRadius: 2,
            fontWeight: 500,
            fontSize: '0.75rem'
          }}
        />
      )
    },
    {
      field: 'createdDate',
      headerName: 'Fecha de Ingreso',
      flex: 1.2,
      renderCell: (params) => {
        const joinDate = moment(params?.value);
        const daysSinceJoined = moment().diff(joinDate, 'days');

        return (
          <Box>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <CalendarIcon sx={{ fontSize: 14, color: theme.palette.text.secondary }} />
              <Typography variant="body2" fontWeight={500}>
                {joinDate.format('DD/MM/YYYY')}
              </Typography>
            </Stack>
            <Typography variant="caption" color="text.secondary">
              Hace {daysSinceJoined} días
            </Typography>
          </Box>
        );
      }
    },
    {
      field: 'isActive',
      headerName: 'Estado',
      flex: 0.8,
      renderCell: (params) => {
        const isActive = params.row.isActive !== false;
        return (
          <Chip
            label={isActive ? 'Activo' : 'Inactivo'}
            color={isActive ? 'success' : 'error'}
            size="small"
            variant={isActive ? 'filled' : 'outlined'}
            sx={{
              borderRadius: 2,
              fontWeight: 500,
              fontSize: '0.75rem'
            }}
          />
        );
      }
    },
    {
      field: 'salary',
      headerName: 'Salario',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center">
            <MoneyIcon sx={{ fontSize: 14, mr: 0.5, color: theme.palette.success.main }} />
            <Typography variant="body2" fontWeight={600} color="success.main">
              {currency} {params.value?.toLocaleString()}
            </Typography>
          </Box>
        );
      }
    },
    {
      field: 'action',
      headerName: 'Acciones',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        console.log('params ===>', params);
        return (
          <Box>
            <IconButton
              aria-describedby={params?.row._id}
              variant="contained"
              onClick={(event) => handleClick(event, params?.row)}
              sx={{
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                '&:hover': {
                  bgcolor: alpha(theme.palette.primary.main, 0.2)
                }
              }}
            >
              <MoreVertIcon sx={{ color: theme.palette.primary.main }} />
            </IconButton>

            <Popover
              id={params?.row._id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  boxShadow: theme.shadows[8],
                  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                  minWidth: 200
                }
              }}
            >
              <MenuItem onClick={() => handleOpenEditEmployee(params?.row._id)} disableRipple sx={{ py: 1.5, px: 2 }}>
                <EditActionIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.primary.main }} />
                <Typography variant="body2" fontWeight={500}>
                  Editar
                </Typography>
              </MenuItem>
              <MenuItem onClick={() => handleOpenview(params.row._id)} disableRipple sx={{ py: 1.5, px: 2 }}>
                <ViewIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.success.main }} />
                <Typography variant="body2" fontWeight={500}>
                  Ver Detalles
                </Typography>
              </MenuItem>
              <MenuItem onClick={() => handleToggleStatus(params.row._id, params.row.isActive)} disableRipple sx={{ py: 1.5, px: 2 }}>
                {params.row.isActive !== false ? (
                  <>
                    <BlockIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.error.main }} />
                    <Typography variant="body2" fontWeight={500} color="error">
                      Desactivar Cuenta
                    </Typography>
                  </>
                ) : (
                  <>
                    <CheckCircleOutlineIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.success.main }} />
                    <Typography variant="body2" fontWeight={500} color="success.main">
                      Activar Cuenta
                    </Typography>
                  </>
                )}
              </MenuItem>

              <Divider sx={{ my: 1 }} />

              <MenuItem variant="contained" onClick={(event) => handlePermissionsClick(event, params.row)} sx={{ py: 1.5, px: 2 }}>
                <SecurityIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.warning.main }} />
                <Typography variant="body2" fontWeight={500}>
                  Gestionar Permisos
                </Typography>
              </MenuItem>

              <Popover
                open={openPermissions}
                anchorEl={permissionsAnchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                PaperProps={{
                  sx: {
                    borderRadius: 2,
                    boxShadow: theme.shadows[12],
                    maxHeight: 400,
                    width: 300
                  }
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    Permisos de Acceso
                  </Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    Selecciona los módulos a los que tendrá acceso
                  </Typography>
                </Box>
                <Divider />
                <List sx={{ maxHeight: 280, overflow: 'auto' }}>
                  {menuItems.map((item) => (
                    <ListItem key={item} dense>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedPermissions?.includes(item)}
                            onChange={handlePermissionsChange}
                            name={item}
                            size="small"
                          />
                        }
                        label={<Typography variant="body2">{item}</Typography>}
                        sx={{ width: '100%' }}
                      />
                    </ListItem>
                  ))}
                </List>
                <Divider />
                <Box sx={{ p: 2 }}>
                  <Button variant="contained" onClick={() => handleSavePermissions(rowData?._id)} fullWidth sx={{ borderRadius: 2 }}>
                    Guardar Permisos
                  </Button>
                </Box>
              </Popover>

              <MenuItem variant="contained" onClick={() => handleOpenChangeShift(params.row)} sx={{ py: 1.5, px: 2 }}>
                <ScheduleIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.info.main }} />
                <Typography variant="body2" fontWeight={500}>
                  Cambiar Turno
                </Typography>
              </MenuItem>
            </Popover>
          </Box>
        );
      }
    }
  ];

  return (
    <>
      <AddProperty open={openAdd} handleClose={handleCloseAdd} />
      <EditEmployee open={openEdit} handleClose={handleCloseEditEmployee} employeeData={rowData} />
      <ChangeShift open={openChangeShift} handleClose={handleCloseChangeShift} employeeID={employeeID} currentShift={currentShift} />

      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            color: 'white',
            borderRadius: 3
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Administración de Personal
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9 }}>
                Gestiona empleados, turnos y permisos de acceso al sistema
              </Typography>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <GroupsIcon sx={{ fontSize: 60, opacity: 0.3 }} />
            </Box>
          </Stack>
        </Paper>

        {/* Statistics Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <PersonIcon sx={{ color: theme.palette.primary.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="primary">
                    {totalEmployees}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total de Empleados
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <TrendingUpIcon sx={{ color: theme.palette.success.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="success.main">
                    {currency} {totalSalaries.toLocaleString()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Nómina Total
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.info.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <MoneyIcon sx={{ color: theme.palette.info.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="info.main">
                    {currency} {averageSalary.toLocaleString(undefined, { maximumFractionDigits: 0 })}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Salario Promedio
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>

        {/* Controls Section */}
        <Card sx={{ p: 3, mb: 3, borderRadius: 3, border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" spacing={2} justifyContent="space-between">
            <Box>
              <Typography variant="h6" fontWeight={600}>
                Gestión de Empleados
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Agrega empleados, asigna permisos y gestiona turnos de trabajo
              </Typography>
            </Box>

            <Stack direction="row" spacing={2} alignItems="center">
              <FormControlLabel
                control={
                  <Switch
                    checked={showInactive}
                    onChange={(e) => setShowInactive(e.target.checked)}
                    color="primary"
                  />
                }
                label={<Typography variant="body2" fontWeight={500}>Mostrar Inactivos</Typography>}
              />
              <Button
                variant="contained"
                startIcon={<PersonAddIcon />}
                onClick={handleOpenAdd}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                  py: 1.2,
                  boxShadow: theme.shadows[3],
                  '&:hover': {
                    boxShadow: theme.shadows[6]
                  }
                }}
              >
                Agregar Empleado
              </Button>
            </Stack>
          </Stack>
        </Card>

        {/* Data Table */}
        <Card
          sx={{
            borderRadius: 3,
            overflow: 'hidden',
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            '& .MuiDataGrid-root': {
              border: 'none',
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: alpha(theme.palette.primary.main, 0.05),
                borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                '& .MuiDataGrid-columnHeader': {
                  fontWeight: 600,
                  fontSize: '0.875rem'
                }
              },
              '& .MuiDataGrid-row': {
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.02)
                }
              },
              '& .MuiDataGrid-cell': {
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`
              }
            }
          }}
        >
          <Box sx={{ p: 3, pb: 1 }}>
            <Typography variant="h6" fontWeight={600} color="primary">
              Lista de Empleados ({totalEmployees})
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Haz clic en un empleado para ver su perfil completo
            </Typography>
          </Box>

          <TableStyle>
            <Box sx={{ height: '70vh', width: '100%' }}>
              <DataGrid
                rows={filteredStaffData}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10
                    }
                  }
                }}
                pageSizeOptions={[5, 10, 25]}
                disableRowSelectionOnClick
                getRowId={(row) => row?._id}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: {
                      debounceMs: 500,
                      placeholder: 'Buscar empleados...'
                    }
                  }
                }}
                sx={{
                  '& .MuiDataGrid-toolbarContainer': {
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    p: 2
                  }
                }}
              />
            </Box>
          </TableStyle>
        </Card>
      </Container>
    </>
  );
};

export default StaffManagment;
